import TurnstileWidget from '../common/TurnstileWidget';
import { useQuoteForm } from '../../hooks/useQuoteForm';
import '../../styles/home/Contact.css';

function Contact() {
  const {
    formData,
    handleInputChange,
    handleSubmit,
    isSubmitting,
    submitStatus,
    canSubmit,
    turnstileEnabled,
    turnstileProps,
  } = useQuoteForm({
    successMessage: 'Thank you for your inquiry! We will contact you soon.',
  });

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="contact-wrapper">
          <div className="contact-info">
            <h2>Get Your Free Quote Today</h2>
            <p>Ready to transform your space? Contact us for a free consultation and quote.</p>
            
            <div className="contact-details">
              <div className="contact-item">
                <h4>📞 Phone</h4>
                <p><a href="tel:7705901666">+1 (770) 590-1666</a></p>
              </div>
              
              <div className="contact-item">
                <h4>💬 Text</h4>
                <p><a href="tel:+14047033838">+1 (404) 703-3838</a></p>
              </div>
              
              <div className="contact-item">
                <h4>📧 Email</h4>
                <p><a href="mailto:sonnyblindpromo@gmail.com">sonnyblindpromo@gmail.com</a></p>
              </div>

              <div className="contact-item">
                <h4>🏢 Address</h4>
                <p><a href="https://www.google.com/maps/place/1680+Roberts+Blvd+%23403,+Kennesaw,+GA+30144/@34.0047566,-84.5979895,17z/data=!3m1!4b1!4m5!3m4!1s0x88f5156f7c9e03cd:0xd95e69e2c2c31e24!8m2!3d34.0047566!4d-84.5954146?entry=ttu&g_ep=EgoyMDI2MDMwOS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">1680 Roberts Blvd NW Ste 403, Kennesaw, GA, United States, 30144</a></p>
              </div>
              
              <div className="contact-item">
                <h4>🕒 Hours</h4>
                <p>Monday - Friday: 8am - 5pm (By Appointment)</p>
              </div>

              <div className="contact-item">
                <h4>🌐 Follow Us</h4>
                <div className="social-links">
                  <a href="https://www.facebook.com/p/Sony-Blind-Factory-100066608982517/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">Facebook</a>
                </div>
              </div>
            </div>
          </div>
          
          <div id="quote" className="contact-form">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                ></textarea>
              </div>

              {turnstileEnabled ? <TurnstileWidget {...turnstileProps} /> : null}
              
              {submitStatus ? (
                <p
                  className={`contact-form-status contact-form-status-${submitStatus.type}`}
                  role="alert"
                  aria-live="polite"
                >
                  {submitStatus.message}
                </p>
              ) : null}

              <button type="submit" className="btn btn-primary btn-block" disabled={!canSubmit}>
                {isSubmitting ? 'Sending...' : 'Request Free Quote'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
